import React from "react";
import { Link } from "react-router-dom";
import { Mountain, Flame, Users } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1622781656198-645b7981b671?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxNzkxNTczNjkwfDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="overline">About the Portal</div>
      <h1 className="font-serif text-5xl lg:text-6xl text-[#4A0E17] mt-2 leading-tight">Pancham Dham — the Fifth Abode</h1>
      <p className="text-[#63534E] mt-6 text-lg max-w-3xl leading-relaxed">
        In the lineage of Shiva's sacred dhams, Pancham Dham rises from the Khmer soil of Cambodia — a bridge between the ancient Sanskrit heritage of Angkor and the living devotional current of Bharat.
      </p>

      <div className="mt-14 grid lg:grid-cols-2 gap-12 items-center">
        <img src={IMG} alt="Shiva" className="rounded-3xl sacred-border w-full h-96 object-cover" />
        <div>
          <h2 className="font-serif text-3xl text-[#4A0E17]">Why this portal exists</h2>
          <p className="text-[#1F1412] mt-5 leading-relaxed">
            For centuries, the 1008 Names of Shiva have been preserved by oral tradition — chanted at dawn, taught by gurus, carved in sandstone. This portal places that heritage in every devotee's pocket. Chant from Delhi, donate from Dubai, book your pilgrimage from Toronto.
          </p>
          <p className="text-[#63534E] mt-4 leading-relaxed">
            Every seva funds the ongoing restoration of Pancham Dham, daily aarti, annadaan for pilgrims, and scholarship programs for Khmer Vedic students.
          </p>
        </div>
      </div>

      <div className="mt-20 grid md:grid-cols-3 gap-6">
        {[
          { icon: Mountain, title: "A living heritage", desc: "Khmer-Shaiva temples span 1200+ years, preserved by scholars and devotees." },
          { icon: Flame, title: "Daily dharma", desc: "Rudrabhishekam, aarti, and annadaan performed every single day without pause." },
          { icon: Users, title: "A global sangha", desc: "Pilgrims from India, SE Asia, and the diaspora walk the Pancham Dham path together." },
        ].map((c) => (
          <div key={c.title} className="bg-[#FFFDF9] sacred-border rounded-2xl p-7">
            <c.icon className="w-8 h-8 text-[#E65100]" />
            <h3 className="font-serif text-xl text-[#4A0E17] mt-5">{c.title}</h3>
            <p className="text-[#63534E] mt-3 leading-relaxed">{c.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-20 text-center">
        <Link to="/pilgrimage" className="btn-saffron">Plan your yatra →</Link>
      </div>
    </div>
  );
}
